import { render } from "./DevelopersSearch.vue?vue&type=template&id=b70a6c38&scoped=true"
import script from "./DevelopersSearch.vue?vue&type=script&lang=js"
export * from "./DevelopersSearch.vue?vue&type=script&lang=js"

import "./DevelopersSearch.vue?vue&type=style&index=0&id=b70a6c38&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b70a6c38"]])

export default __exports__